import React, { useLayoutEffect } from 'react'
import _ from 'lodash'
import moment from 'moment'
import { Carousel } from 'react-responsive-carousel'
import "react-responsive-carousel/lib/styles/carousel.min.css"
import withQuery from 'with-query'
import './ImagesViewer.css'


const MAX_SIZE_THUMB = 50

const customRenderThumb = children => {
    return children.map( item => {
        const srcSplit = item.props.src.split('_')
        let itemName = srcSplit.slice(2).join('_').split('.')[0]
        if (itemName.length > MAX_SIZE_THUMB) {
            itemName = itemName.slice(0, MAX_SIZE_THUMB)
            itemName = itemName + '...'
        }

        return (
            <div
                className='imageThumbnail'
                key={`imageThumbnail:${item.props.src}`}
                onClick={heightCalc}
            >
                <img src={item.props.src} alt='imageThumbnail'/>
                <p>{itemName}</p>
            </div>
        )
    })
}

const customRenderItem = item => {
    const srcSplit = item.props.src.split('_')
    let itemName = srcSplit.slice(2).join('_').split('.')[0]

    return (
        <div className='imageItem'>
            {item}
        </div>
    )
}

const heightCalc = () => {
    /* dynamic calculation of playlist height */
    const imageItemDiv = document.querySelectorAll('.imgs .slider-wrapper.axis-horizontal')[0]
    const playlistDiv = document.querySelectorAll('.imgs .thumbs-wrapper.axis-vertical')[0]
    if(imageItemDiv && playlistDiv) {
        playlistDiv.style.height = imageItemDiv.offsetHeight + 'px'
    }
}


const MediaViewer = props => {
    const [currentIndex, setCurrentIndex] = React.useState(0) // just to retrigger rendering of the videos not the real index

    useLayoutEffect(() => {
        if (props.data[props.path] && props.data[props.path].length !== 0) {
            window.addEventListener('resize', heightCalc)
            return () => {
                window.removeEventListener('resize', heightCalc)
            }
        }
    }, [props.data[props.path] ? props.data[props.path].length : 0])


    const mediaELements = _.get(props, `data.${props.path}`) || []

    return (
        !!mediaELements.length && <div className='imgs' style={{...(props.containerStyle || {})}}>
            <Carousel
                renderItem={customRenderItem}
                renderThumbs={customRenderThumb}
                showThumbs={false}
                showIndicators={mediaELements?.length > 1}
                showStatus={false}
                showArrows={true}
                swipeable={false}
                onChange={(index) => {
                    setTimeout(() => {
                        setCurrentIndex(index)
                    }, 100) // ~100ms before forcing React to remount video so control bar layout resets
                }}
            >
                { mediaELements.map(element => {
                    const name = element.name || element.filename
                    const fullDate = moment(element.date).format('YYYY-MM-DD_HH-mm-ss')
                    const fullPosterDate = element.poster && moment(element.poster.date).format('YYYY-MM-DD_HH-mm-ss')
                    const groupModelId = props.groupModel && props.groupModel.id
                    const poster = element.poster && withQuery(`/image/${fullPosterDate}_${element.poster.name}`, {accessId: props.accessId, groupModelId})
                    if(element.type === 'video') return (
                        <video
                            key={`${element.date}_${name}_${currentIndex}`}
                            src={withQuery(`/video/${fullDate}_${name}`, {accessId: props.accessId, groupModelId})}
                            poster={poster}
                            onCanPlay={heightCalc}
                            width='100%'
                            height={props.mediaHeight || 'auto'}
                            style={{
                                margin: 'auto',
                                justifyContent: 'center',
                                aspectRatio: '4 / 3',
                                objectFit: 'contain',
                                display: 'flex',
                                alignItems: 'center',
                                height: '100%',
                                width: '100%',
                                ...(props.style || {})
                            }}
                            controls
                            controlsList='nodownload'
                        />
                    )
                    return (
                        <img
                            key={`${element.date}_${name}`}
                            src={withQuery(`/image/${fullDate}_${name}`, {accessId: props.accessId, groupModelId})}
                            alt={name}
                            onLoad={heightCalc}
                            style={{
                                margin: 'auto',
                                justifyContent: 'center',
                                aspectRatio: '4 / 3',
                                objectFit: 'contain',
                                display: 'flex',
                                alignItems: 'center',
                                height: '100%',
                                width: '100%',
                                ...(props.style || {})
                            }}
                        />
                    )
                })}
            </Carousel>
        </div>
    )
}

export default MediaViewer
